// HeyCatch analytics loads as a module script in public/index.html (the npm build needs Node 22).
// Calls made before it finishes loading are queued and replayed after init.
export function hc(method, ...args) {
  if (typeof window === "undefined") return;
  if (window.heycatch) window.heycatch[method](...args);
  else (window.__hcq = window.__hcq || []).push([method, args]);
}

let lastId = null;

export function identifyUser(u) {
  if (!u?.user_id || u.user_id === lastId) return;
  lastId = u.user_id;
  hc("setIdentity", u.user_id, { email: u.email, name: u.name }, { signup_date: u.created_at });
}

export function resetUser() {
  lastId = null;
  hc("resetIdentity");
}

// Once per Stripe checkout session, after the backend confirms it paid.
export function trackSubscriptionStarted(status) {
  const key = `umbra_hc_sub_${status.session_id}`;
  if (status.mode !== "subscription" || window.sessionStorage.getItem(key)) return;
  window.sessionStorage.setItem(key, "1");
  const plan = status.lookup_key || "subscriber";
  hc("setPersonProperties", { plan });
  hc("trackEvent", "subscription_started", { plan });
}
